const escapeHtml = (value) => String(value ?? '')
  .replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;')
  .replace(/'/g, '&#39;')

const isUnsafeUrl = (url) => /^\s*(javascript|data|vbscript):/i.test(url || '')

function renderChildren(children) {
  if (!Array.isArray(children)) {
    return ''
  }
  return children
    .map((child) => {
      if (child.type === 'link') {
        const linkText = renderChildren(child.children)
        const href = isUnsafeUrl(child.url) ? '#' : escapeHtml(child.url)
        return `<a href="${href}" target="_blank" rel="noopener noreferrer">${linkText}</a>`
      }
      return escapeHtml(child.text)
    })
    .join('')
}

export function blocksToHtml(blocks) {
  if (!Array.isArray(blocks) || blocks.length === 0) {
    return ''
  }
  return blocks
    .map((block) => {
      if (block.type === 'paragraph') {
        return `<p>${renderChildren(block.children)}</p>`
      }
      return ''
    })
    .join('')
}

export function blocksToPlainText(blocks) {
  if (!Array.isArray(blocks)) {
    return ''
  }
  return blocks
    .map((block) => {
      if (block.type !== 'paragraph') {
        return ''
      }
      return (block.children || [])
        .map((child) => {
          if (child.type === 'link') {
            return (child.children || []).map((c) => c.text || '').join('')
          }
          return child.text || ''
        })
        .join('')
    })
    .filter(Boolean)
    .join(' ')
    .trim()
}
